import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import InteractiveBackground from './components/InteractiveBackground';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import CreateTask from './pages/CreateTask';
import TaskDetails from './pages/TaskDetails';
import ProgressOverview from './pages/ProgressOverview';
import Teams from './pages/Teams';
import CreateTeam from './pages/CreateTeam';
import TeamDetails from './pages/TeamDetails';
import TaskHistory from './pages/TaskHistory';
import TimeTracking from './pages/TimeTracking';
import UsersList from './pages/UsersList';

function App() {
  return (
    <AuthProvider>
      <InteractiveBackground />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/create-task"
            element={
              <PrivateRoute>
                <CreateTask />
              </PrivateRoute>
            }
          />
          <Route
            path="/task/:id"
            element={
              <PrivateRoute>
                <TaskDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/teams"
            element={
              <PrivateRoute>
                <Teams />
              </PrivateRoute>
            }
          />
          <Route
            path="/create-team"
            element={
              <PrivateRoute allowedRoles={['admin', 'teamLead']}>
                <CreateTeam />
              </PrivateRoute>
            }
          />
          <Route
            path="/team/:id"
            element={
              <PrivateRoute>
                <TeamDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/progress"
            element={
              <PrivateRoute allowedRoles={['admin', 'productManager', 'teamLead']}>
                <ProgressOverview />
              </PrivateRoute>
            }
          />
          <Route
            path="/history"
            element={
              <PrivateRoute>
                <TaskHistory />
              </PrivateRoute>
            }
          />
          <Route
            path="/time"
            element={
              <PrivateRoute>
                <TimeTracking />
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute allowedRoles={['admin', 'productManager', 'teamLead']}>
                <UsersList />
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

